import { headerConstants } from "../constants/headerConstants"

const initialState = {
  title: "",
  detail: ""
}

export function headerReducer(state = initialState, action) {
  switch (action.type) {
    case headerConstants.UPDATE_HEADER_TITLE:
      return {
        ...state,
        title: action.value.title,
        number: action.value.number,
        detail: action.value.detail,
        course: action.value.course,
        assessment: {}
      }

    case "UPDATE_HEADER_TITLE2":
      return {
        ...state,
        assessment: action.value
      }

    default:
      return state
  }
}
